<div class="card-grid">
  <div class="offer-card">
    <div class="offer-card__image-wrapper">
      @if (offerItem().photos.length) {
        <img
          *ngIf="getFirstPhoto(offerItem()) as src"
          [src]="src"
          alt="no-photo"
          class="offer-card__image"
          loading="lazy" />
      } @else {
        <div class="no-img-box">
          <img
            src="../../../../assets/no-img.png"
            alt="no-photo"
            class="no-img-box__img"
            loading="lazy" />
          <div class="no-img-box__text">Photo not provided.</div>
        </div>
      }
    </div>

    <div class="card-content">
      <div class="offer-card__title">
        {{ offerItem().title }}
      </div>
      <div class="offer-card__location">
        <div class="offer-card__distance">
          <span class="offer-card__distance_num"
            >{{ offerItem().distanceFromHome | number: '1.2-2' }} km
          </span>
          <span class="offer-card__distance_p"></span> away from home
        </div>
      </div>
      <div class="offer-card__address">
        {{ offerItem().address }}
      </div>
      <div class="offer-card__features" *ngIf="offerItem() as offer">
        <ng-container *ngFor="let feature of listFeatureIcons">
          <span *ngIf="hasFeature(offer.features, feature.key)">
            {{ feature.icon }} {{ feature.label }}
          </span>
        </ng-container>
      </div>

      <div class="offer-card__actions">
        <button
          mat-raised-button
          color="primary"
          (click)="goToOffer.emit(offerItem().id)">
          View
        </button>
      </div>
    </div>
  </div>
</div>
